import React, { SVGProps } from "react";

export const AdinFive = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={119}
      height={120}
      viewBox="0 0 119 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={59.5091}
        cy={60.1883}
        r={59.2722}
        fill="white"
        fillOpacity={0.59}
      />
      <g clipPath="url(#clip0_3218_4953)">
        <path
          d="M92.7013 53.0767C92.7013 46.0951 84.6764 39.9089 72.4565 37.2454V26.9961H66.1949V54.4237L68.4902 54.8255C74.277 55.8372 79.0347 57.7579 82.1964 60.1913C79.0347 62.622 74.277 64.5455 68.4902 65.5571L66.1949 65.959V80.1273C64.0578 80.3961 61.8152 80.5403 59.5111 80.5403C57.2069 80.5403 54.9643 80.3961 52.8273 80.1273V65.959L50.5319 65.5571C44.7452 64.5455 39.9874 62.6248 36.8258 60.1913C39.9874 57.7606 44.7452 55.8372 50.5319 54.8255L52.8273 54.4237V26.9961H46.5656V37.2426C41.3461 38.379 36.8038 40.1833 33.2772 42.5336C28.7217 45.5685 26.3164 49.2131 26.3164 53.0767C26.3164 55.5905 27.3717 58.0045 29.2845 60.1886C27.3673 62.3753 26.3164 64.7894 26.3164 67.3004C26.3164 71.9733 29.8606 76.3386 36.2937 79.5952C39.3014 81.1168 42.784 82.3058 46.5612 83.1317V93.381H52.8229V84.135C54.9995 84.3651 57.2377 84.4842 59.5067 84.4842C61.7756 84.4842 64.0138 84.3651 66.1904 84.135V93.381H72.4521V83.1317C76.2293 82.3058 79.7119 81.1168 82.7196 79.5952C89.1528 76.3413 92.6969 71.9733 92.6969 67.3004C92.6969 64.7866 91.6416 62.3726 89.7288 60.1886C91.646 58.0018 92.6969 55.5877 92.6969 53.0767H92.7013ZM32.5781 53.0767C32.5781 48.2264 38.1186 43.778 46.5612 41.4804V51.4719C41.3681 52.6055 36.9357 54.3821 33.5498 56.5855C32.9166 55.4602 32.5781 54.2823 32.5781 53.0794V53.0767ZM32.5781 67.3004C32.5781 66.0976 32.9166 64.9196 33.5498 63.7944C36.9357 65.995 41.3725 67.7716 46.5612 68.9052V78.9023C38.2329 76.649 32.5781 72.292 32.5781 67.3004ZM72.4565 51.4692V41.4748C80.9739 43.7725 86.4397 48.1904 86.4397 53.0767C86.4397 54.2795 86.1011 55.4575 85.4679 56.5827C82.082 54.3821 77.6452 52.6055 72.4565 51.4719V51.4692ZM86.4397 67.3004C86.4397 72.2948 80.7848 76.649 72.4565 78.9023V68.9052C77.6496 67.7716 82.082 65.995 85.4679 63.7916C86.1011 64.9169 86.4397 66.0948 86.4397 67.2977V67.3004Z"
          fill="#169FED"
        />
      </g>
      <defs>
        <clipPath id="clip0_3218_4953">
          <rect
            width={66.3849}
            height={66.3849}
            fill="white"
            transform="translate(26.3164 26.9951)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
